import type { SensitiveCredentialsApi } from '~/services/sensitive-credentials-api/sensitive-credentials-api.types';

export type CredentialPlatformGroup =
  | {
    credentials: SensitiveCredentialsApi.Credential[];
    kind: 'multiple';
    platform: string;
  }
  | {
    credential: SensitiveCredentialsApi.Credential;
    kind: 'single';
    platform: string;
  };

export function buildCredentialPlatformGroups(
  items: SensitiveCredentialsApi.Credential[],
): CredentialPlatformGroup[] {
  const byPlatform = new Map<string, SensitiveCredentialsApi.Credential[]>();

  for (const credential of items) {
    const list = byPlatform.get(credential.manufacture_platform) ?? [];
    list.push(credential);
    byPlatform.set(credential.manufacture_platform, list);
  }

  return [...byPlatform.entries()]
    .sort(([platformA], [platformB]) => platformA.localeCompare(platformB, 'pt-BR'))
    .map(([platform, credentials]) => {
      if (credentials.length === 1) {
        return {
          credential: credentials[0],
          kind: 'single',
          platform,
        };
      }
      return {
        credentials,
        kind: 'multiple',
        platform,
      };
    });
}
